import { render, staticRenderFns } from "./ClientManager.vue?vue&type=template&id=fdc42972&scoped=true"
import script from "./ClientManager.vue?vue&type=script&lang=js"
export * from "./ClientManager.vue?vue&type=script&lang=js"
import style0 from "./ClientManager.vue?vue&type=style&index=0&id=fdc42972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdc42972",
  null
  
)

export default component.exports